<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h3 class="panel-title">
        Sessions Over Time
        <CalculationTooltip text="Shows completed sessions grouped by the selected granularity (daily/weekly/monthly). The dashed line shows the comparison period." />
      </h3>
    </div>
    <div class="panel-body">
      <LineChart v-if="chartData" :key="chartKey" :data="chartData" :options="chartOptions" />
    </div>
  </div>
</template>

<script>
import { Line as LineChart } from 'vue-chartjs';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Filler,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import CalculationTooltip from './CalculationTooltip.vue';

ChartJS.register(CategoryScale, LinearScale, LineElement, PointElement, Filler, Title, Tooltip, Legend);

export default {
  name: 'TimeSeriesChart',
  components: { LineChart, CalculationTooltip },
  props: {
    timeSeries: { type: Array, required: true }
  },
  data: function() {
    return {
      chartKey: 0
    };
  },
  watch: {
    timeSeries: function() {
      this.chartKey++;
    }
  },
  computed: {
    chartData() {
      if (!this.timeSeries || this.timeSeries.length === 0) return null;
      var datasets = [
        {
          label: 'Sessions',
          data: this.timeSeries.map(function(d) { return d.sessions_completed; }),
          borderColor: '#337ab7',
          backgroundColor: 'rgba(51, 122, 183, 0.1)',
          fill: true,
          tension: 0.3
        }
      ];
      if (this.timeSeries[0].yoy_sessions_completed != null) {
        datasets.push({
          label: 'Previous Period',
          data: this.timeSeries.map(function(d) { return d.yoy_sessions_completed; }),
          borderColor: '#999',
          borderDash: [5, 5],
          fill: false,
          tension: 0.3
        });
      }
      return {
        labels: this.timeSeries.map(function(d) { return d.period_label; }),
        datasets: datasets
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: { position: 'top' }
        },
        scales: {
          y: { beginAtZero: true }
        }
      };
    }
  }
};
</script>
